var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_9303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.726562 7.06L3.7799 4L0.726562 0.94L1.66656 0L5.66656 4L1.66656 8L0.726562 7.06Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_9303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.33333,
    height: 8,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowRight);
export default __webpack_public_path__ + "static/media/keyboard-arrow-right.1ca03aa88406042136babe3b630aa4eb.svg";
export { ForwardRef as ReactComponent };